/* import SlickSlider from "slick-slider"; */ //Temporarily fixed for Drupal 11 copied script form slickslider and replaced $.type. See slick,js file Maybe we need to replace this library in the future with a more modern one that is still supported and maintained.

window.$ = window.jQuery;

Drupal.behaviors.teaserSlideSection = {
  attach: function (context) {
    let $teaserSlider = $(".teaser-carousel", context);

    let $showArrows = false;
    let $centerPadding = "0px";
    if ($(".teaser-carousel__slider.slider").length) {
      $showArrows = true;
      $centerPadding = "20px";
    }

    if ($teaserSlider.length > 0) {
      $(".teaser-carousel__slider", $teaserSlider)
        .not(".slick-initialized")
        .slick({
          dots: false,
          arrows: $showArrows,
          prevArrow:
            '<button class="chevron-prev">' +
            Drupal.t("Previous") +
            "</button>",
          nextArrow:
            '<button class="chevron-next">' + Drupal.t("Next") + "</button>",
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,

          responsive: [
            {
              breakpoint: 1100,
              settings: {
                arrows: false,
                centerMode: false,
                slidesToShow: 2.1428571428571429,
                slidesToScroll: 2,
                onAfterChange: function () {
                  console.log(slider);
                },
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1.12,
                slidesToScroll: 1,
              },
            },
          ],
        })
        // handle different placement of last teaser slide
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          const tabletBreakpoint = 1100;
          const mobileBreakpoint = 600;

          // on tablet screens and if more than 2 slides run special placement of last slide
          if (
            window.innerWidth <= tabletBreakpoint &&
            window.innerWidth > mobileBreakpoint &&
            slick.$slides.length > 2
          ) {
            let slidesAreOddAmount = slick.$slides.length % 2 ? 0 : 1;

            if (slick.$slides.length - 1 === nextSlide + slidesAreOddAmount) {
              this.style.marginLeft = "-60px";
              this.style.paddingRight = "60px";
            } else {
              this.style.marginLeft = 0;
              this.style.paddingRight = 0;
            }
          }
          // on mobile screens
          else if (
            window.innerWidth < tabletBreakpoint &&
            window.innerWidth <= mobileBreakpoint &&
            slick.$slides.length > 1
          ) {
            if (slick.$slides.length - 1 === nextSlide) {
              this.style.marginLeft = "-25px";
              this.style.paddingRight = "25px";
            } else {
              this.style.marginLeft = 0;
              this.style.paddingRight = 0;
            }
          }
        });

      $teaserSlider.addClass("slick-initialized");
    }
  },
};
